import { cn } from '@lib/util/cn';
import { convertToLocale } from '@lib/util/money';

type CartItemPriceProps = {
  currentTotal: number;
  originalTotal: number;
  currencyCode: string;
  alignStart?: boolean;
};

export function CartItemPrice({
  currentTotal,
  originalTotal,
  currencyCode,
  alignStart,
}: CartItemPriceProps) {
  const hasDiscount = currentTotal < originalTotal;

  return (
    <div
      className={cn('flex flex-col', alignStart ? 'items-start' : 'items-end')}
    >
      {hasDiscount && (
        <span className="typography-caption text-fg-neutral-subtle line-through">
          <span className="sr-only">Original price: </span>
          {convertToLocale({
            amount: originalTotal,
            currency_code: currencyCode,
          })}
        </span>
      )}
      <span
        className="typography-paragraph font-semibold text-fg-interactive-strong"
        data-testid="product-price"
      >
        {hasDiscount && <span className="sr-only">Discounted price: </span>}
        {convertToLocale({ amount: currentTotal, currency_code: currencyCode })}
      </span>
    </div>
  );
}
